"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _components = require("egov-ui-kit/components");

var _Dialog = require("@material-ui/core/Dialog");

var _Dialog2 = _interopRequireDefault(_Dialog);

var _translationNode = require("egov-ui-kit/utils/translationNode");

var _translationNode2 = _interopRequireDefault(_translationNode);

var _DialogActions = require("@material-ui/core/DialogActions");

var _DialogActions2 = _interopRequireDefault(_DialogActions);

var _DialogTitle = require("@material-ui/core/DialogTitle");

var _DialogTitle2 = _interopRequireDefault(_DialogTitle);

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertDialog = function (_Component) {
  (0, _inherits3.default)(AlertDialog, _Component);

  function AlertDialog() {
    (0, _classCallCheck3.default)(this, AlertDialog);
    return (0, _possibleConstructorReturn3.default)(this, (AlertDialog.__proto__ || Object.getPrototypeOf(AlertDialog)).apply(this, arguments));
  }

  (0, _createClass3.default)(AlertDialog, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          open = _props.open,
          handleClose = _props.handleClose,
          labelText = _props.labelText,
          handleSend = _props.handleSend;

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          _Dialog2.default,
          { fullWidth: true, open: open, onClose: handleClose, "aria-labelledby": "max-width-dialog-title", maxWidth: "sm" },
          _react2.default.createElement(
            _DialogTitle2.default,
            { id: "max-width-dialog-title", style: { marginTop: "22px", fontSize: "21px" } },
            labelText
          ),
          _react2.default.createElement(
            _DialogActions2.default,
            { style: { margin: "19px 27px" } },
            _react2.default.createElement(_components.Button, {
              id: "logout-no-button",
              className: "logout-no-button",
              label: _react2.default.createElement(_translationNode2.default, { buttonLabel: true, label: "Cancel", color: "#fff" }),
              backgroundColor: "#939397",
              onClick: handleClose,
              style: { boxShadow: "none", minWidth: "144px", borderRadius: "7px" }
            }),
            _react2.default.createElement(_components.Button, {
              id: "logout-yes-button",
              className: "logout-yes-button",
              label: _react2.default.createElement(_translationNode2.default, { buttonLabel: true, label: "Yes", color: "#fff" }),
              backgroundColor: "#474386",
              onClick: handleSend,
              style: { boxShadow: "none", minWidth: "144px", borderRadius: "7px" }
            })
          )
        )
      );
    }
  }]);
  return AlertDialog;
}(_react.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getComplaintDisplayOrder: function (_getComplaintDisplayOrder) {
      function getComplaintDisplayOrder(_x) {
        return _getComplaintDisplayOrder.apply(this, arguments);
      }

      getComplaintDisplayOrder.toString = function () {
        return _getComplaintDisplayOrder.toString();
      };

      return getComplaintDisplayOrder;
    }(function (order) {
      return dispatch(getComplaintDisplayOrder(order));
    })
  };
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(AlertDialog);


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/components/AlertDialog/index.js
// module id = 2132
// module chunks = 1137